import NavigatableHeader, {
  PodcastTableGoBackButton,
} from 'components/NavigatableHeader';
import {
  useEpisodeTitle,
  usePodcastTitle,
} from 'pages/ContentManagementPage/state';
import React from 'react';

interface ContentManagementPageTitleProps {
  episodeId: number | undefined;
  podcastId: number | undefined;
  onBackClick: () => void;
}

const ContentManagementPageTitle: React.FC<ContentManagementPageTitleProps> = ({
  podcastId,
  episodeId,
  onBackClick,
}) => {
  const { data: podcastTitle } = usePodcastTitle(podcastId);

  const { data: episodeTitle } = useEpisodeTitle(episodeId);

  const subtitle = (() => {
    if (episodeId) {
      return (
        <PodcastTableGoBackButton
          podcastTitle={podcastTitle}
          onClick={onBackClick}
        />
      );
    }
    if (podcastId) {
      return <PodcastTableGoBackButton onClick={onBackClick} />;
    }
    return 'Manage what content from your podcasts can be displayed within your widgets';
  })();

  return (
    <NavigatableHeader
      title={episodeTitle ?? podcastTitle ?? 'Content Management'}
      subtitle={subtitle}
    />
  );
};

export default ContentManagementPageTitle;
